import { render, staticRenderFns } from "./purmodel.vue?vue&type=template&id=435e50f9&scoped=true&"
import script from "./purmodel.vue?vue&type=script&lang=js&"
export * from "./purmodel.vue?vue&type=script&lang=js&"
import style0 from "./purmodel.vue?vue&type=style&index=0&id=435e50f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435e50f9",
  null
  
)

export default component.exports